module.exports = __webpack_public_path__ + "static/hannah-at-work-2453ab520c4d6c187458f0ebb7bc3446.mp4";